/* MASONTEX · Media Core — cache.js (flat asset path)
   Lightweight media payload cache (Map, insertion-order eviction). DOM-free. */
(function (global) {
  'use strict';

  const api = (global.MasontexMediaCore = global.MasontexMediaCore || {});
  const cache = {};

  cache.payloadKey = (color, visor, structure, view) => [color, visor, structure, view].join('|');

  cache.createMediaCache = (limit = 96) => {
    const store = new Map();
    const cap = Math.max(1, Number(limit) || 96);
    return {
      get(key) {
        return store.get(key);
      },
      set(key, value) {
        if (store.has(key)) store.delete(key);
        store.set(key, value);
        if (store.size > cap) {
          const oldest = store.keys().next().value;
          store.delete(oldest);
        }
      },
      has(key) {
        return store.has(key);
      },
      clear() {
        store.clear();
      },
      size: () => store.size
    };
  };

  api.cache = cache;
})(typeof window !== 'undefined' ? window : globalThis);
